import request from '@/request'

export function List() {
  return request({
    url: '/index/Social',
    method: 'get'
  })
}

